"use client";

import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { Card, VStack, Button, Box, Text, HStack, Icon } from "@chakra-ui/react";
import { useLoading } from "@/app/context/LoadingProvider";
import { LuTrophy } from "react-icons/lu";

const links = [{ href: "/Leaderboard", label: "Leaderboard", icon: LuTrophy }];

export default function CommunityNavigationBar({
  onNavigate,
}: {
  onNavigate?: () => void;
}) {
  const pathname = usePathname();
  const { setPageLoading } = useLoading();

  return (
    <Card.Root rounded="xl" borderWidth="1px" bg="bg">
      <Card.Body p={4}>
        <Box mb={4}>
          <Text fontWeight="semibold" lineHeight="1">
            Community
          </Text>
        </Box>

        <VStack align="stretch" gap={1}>
          {links.map((item) => {
            const isExactMatch = pathname === item.href;
            const active = isExactMatch || pathname.startsWith(item.href + "/");

            return (
              <Button
                key={item.href}
                asChild
                variant={active ? "subtle" : "ghost"}
                colorPalette={active ? "teal" : undefined}
                justifyContent="flex-start"
                w="full"
                size="sm"
                h="10"
                rounded="lg"
                px="3"
              >
                <NextLink
                  href={item.href}
                  aria-current={active ? "page" : undefined}
                  onClick={(e) => {
                    if (isExactMatch) {
                      e.preventDefault();
                      onNavigate?.();
                      return;
                    }
                    setPageLoading(true);
                    onNavigate?.();
                  }}
                >
                  <HStack gap={2} w="full">
                    <Icon as={item.icon} boxSize="5" />
                    <Text as="span" flex="1" textAlign="left">
                      {item.label}
                    </Text>
                  </HStack>
                </NextLink>
              </Button>
            );
          })}
        </VStack>
      </Card.Body>
    </Card.Root>
  );
}
